import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";

import jsIcon from "../../assets/img/icons/js.svg";
import mongoIcon from "../../assets/img/icons/mongodb.svg";
import mysqlIcon from "../../assets/img/icons/mysql.svg";
import nodejsIcon from "../../assets/img/icons/nodejs.svg";
import phpIcon from "../../assets/img/icons/php.svg";
import reactIcon from "../../assets/img/icons/react.svg";
// import reduxIcon from "../../assets/img/icons/redux.svg";
import vueIcon from "../../assets/img/icons/vue.svg";

class Hero3 extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    //text
    this.tl.fromTo(this.aboutText, 1, { opacity: 0 }, { delay: 0, opacity: 1 });

    //icons
    this.tl.staggerFromTo(
      ".devIcon img",
      0.5,
      { transform: "translateY(150px)" },
      { transform: "translateY(0px)", ease: Back.easeOut },
      0.1
    );

    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.hero,
      time,
      {
        opacity: 1
      },
      {
        transform: "translateX(-70px)",
        opacity: 0
      }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div id="hero3" className="section" ref={hero => (this.hero = hero)}>
        <div className="aboutText" ref={c => (this.aboutText = c)}>
          Every web & mobile project is built primarily using open source
          technologies and are tailor made to fit unique requirements. Our aim
          has always been to deliver cutting edge user interfaces and
          experiences coupled with rock solid backend programming.
        </div>

        <div className="devIcons" ref={c => (this.devIcons = c)}>
          <div className="devIcon">
            <img src={jsIcon} className="js" alt="icon" />
          </div>
          <div className="devIcon">
            <img src={reactIcon} className="react" alt="icon" />
          </div>
          <div className="devIcon">
            <img src={nodejsIcon} className="nodejs" alt="icon" />
          </div>
          <div className="devIcon wide">
            <img src={mongoIcon} className="mongo" alt="icon" />
          </div>
          <div className="devIcon">
            <img src={vueIcon} className="vue" alt="icon" />
          </div>
          <div className="devIcon">
            <img src={mysqlIcon} className="mysql" alt="icon" />
          </div>
          <div className="devIcon">
            <img src={phpIcon} className="php" alt="icon" />
          </div>
        </div>
      </div>
    );
  };
}

export default Hero3;



// WEBPACK FOOTER //
// ./src/components/Front/Hero3.js